module.exports = {
      id: "unchecked-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#unchecked",
      toString: function () {
        return this.url;
      }
    }